var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_6822)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00857 2.48008C7.5976 0.891059 9.75278 -0.00164795 12 -0.00164795C14.2472 -0.00164795 16.4024 0.891057 17.9915 2.48008C19.5804 4.06911 20.4732 6.22429 20.4732 8.47151V16.0368C20.4732 16.5669 20.6837 17.0754 21.0587 17.4503C21.484 17.8756 21.8183 18.0357 22.2857 18.0357C22.7591 18.0357 23.1429 18.4193 23.1429 18.8928C23.1429 19.3661 22.7591 19.75 22.2857 19.75H1.71432C1.24093 19.75 0.857178 19.3661 0.857178 18.8928C0.857178 18.4193 1.24093 18.0357 1.71432 18.0357C2.18181 18.0357 2.51602 17.8756 2.94139 17.4503C3.31625 17.0754 3.52683 16.5669 3.52683 16.0368V8.47151C3.52683 6.22429 4.41955 4.06911 6.00857 2.48008ZM9.00004 22.7143C9.00004 22.0043 9.57568 21.4286 10.2857 21.4286H13.7143C14.4244 21.4286 15 22.0043 15 22.7143C15 23.4244 14.4244 24 13.7143 24H10.2857C9.57568 24 9.00004 23.4244 9.00004 22.7143Z",
    fill: "#C98819"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_6822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.4a77c49460bbe3c7c2aadaaeaf9aa279.svg";
export { ForwardRef as ReactComponent };